import { Component, OnInit } from '@angular/core';
import { GenesysCloudService } from 'src/app/services/genesys-cloud.service';


@Component({
  selector: 'app-alis-sso',
  templateUrl: './alis-sso.component.html',
  styleUrls: ['./alis-sso.component.scss']
})
export class ALISSSOComponent implements OnInit {
  
//CCR3-13543 - ALIS SSO Integration
  constructor(public ALISservice:GenesysCloudService) { }

  /*istanbul ignore else*/
  ngOnInit(): void {
   this.ALISservice.initialize();
    this.ALISservice.sendMessage(true);
  }

}
